import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";

import { CarrierInsuranceDocs } from "components/CarrierInsuranceDocs";
import { EvotruxDivider } from "components/EvotruxDivider";
import { useRoleContext } from "hooks";

import type { CompanyProfile } from "types/company";

interface Props {
  companyProfile: CompanyProfile;
}

export function CarrierAbout(props: Props) {
  const { companyProfile } = props;
  const { company } = useRoleContext();

  const isOwnCompany = company?.id === companyProfile.company.id;
  const { description } = companyProfile.company;
  const hasDescription = description != null && description.trim() !== "";

  // Both columns stretch to the row's height, so the About and insurance cards
  // end on the same line however long the description is.
  return (
    <Grid container spacing={4}>
      <Grid item xs={12} md={8} sx={{ display: "flex" }}>
        <Stack spacing={1} sx={{ flex: 1 }}>
          <Typography variant="h4">About</Typography>
          <EvotruxDivider />
          <Card sx={{ flex: 1 }}>
            <CardContent>
              {hasDescription ? (
                <Typography sx={{ whiteSpace: "pre-line" }}>
                  {description}
                </Typography>
              ) : (
                <Typography color="text.secondary">
                  {isOwnCompany
                    ? "Add a description so shippers can learn about your company."
                    : "This carrier has not added an about description yet."}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Stack>
      </Grid>
      <Grid item xs={12} md={4} sx={{ display: "flex" }}>
        <Stack spacing={1} sx={{ flex: 1 }}>
          <Typography variant="h4">Insurance & Documents</Typography>
          <EvotruxDivider />
          <CarrierInsuranceDocs
            companyProfile={companyProfile}
            chipSize="small"
          />
        </Stack>
      </Grid>
    </Grid>
  );
}
